<!-- 二维码登录页 -->
<template>
	
</template>

<script>
 import * as api from '@/api'
 import { mapMutations } from 'vuex';
 import JmmToast from '@/components/JmmToast'
 import wxlogin from 'vue-wxlogin';
  export default {
    name: 'waploginback',
    data () {
      return {
        //登录appId
        appid:"wxec7e055bb57fcca7",
        //token值
        token: "fjenpjlnjinhejcmcnkhcefeehlcaidf"
      }
    },
    created() {
      this.merchantId = this.$route.query.merchantId;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      }
    },
    components: {
      wxlogin
    },
    computed: {
   
    },
    mounted() {
      this.getCode();
    },
    methods: {
       handleCommand(command) {
        console.log('click on item ' + command)
      },
      // 非静默授权，第一次有弹框
      getCode(){
        //如果sessionkey不为空,直接返回给业务
        var reSESSIONKEY = localStorage.getItem("reSESSIONKEY");
        if(null != reSESSIONKEY && '' != reSESSIONKEY && undefined != reSESSIONKEY){   
          window.parent.jumpUrl();
          return;
        }
        //清空本地信息
        localStorage.clear();
		    // 截取code
		    var code = this.getUrlCode().code;
        console.info("code=" + code);
        // 如果没有code，则去请求
		    if (null == code || '' == code || undefined == code) {
		      //跳转首页登录
          window.top.location.href = "waplogin.html#/?timeer=66666";
          window.top.location.reload();
          window.location.reload();
		    } else {
		        this.getLogin(code);
		    }
		  },
      //点击获取登录内容
      async getLogin(codeMes){
        console.info("codeMes=" + codeMes);
        let _this = this;
        try {
          let info={
              appId: this.appid,
              wxcode: codeMes
          };
          localStorage.setItem("reToken",this.token);
          const { code, data, message } =  await api.user.getwebLogin(info);
          if (code == "000000") {
             localStorage.setItem("reSESSIONKEY", data.SESSIONKEY);
             localStorage.setItem("reSIGN", data.sign);
             console.info("jumpUrl code=" + code);
             window.parent.jumpUrl();
             return;
          }
          else {
            console.log(data);
            HyrToast(submsg || msg)
          }
        } catch (err) {
          console.log(err);
        }
      },
      getUrlCode() { // 截取url中的code方法
		    var url = location.search
		    var theRequest = new Object()
		    if (url.indexOf("?") != -1) {
		      var str = url.substr(1)
		      var strs = str.split("&")
		      for(var i = 0; i < strs.length; i ++) {
		          theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
		      }
		    }
		    return theRequest
		  },
    },
  }
</script>

<style lang="stylus">

</style>


// WEBPACK FOOTER //
// src/view/waploginback/index.vue